import React from 'react'
const Footer = () => {

  


  return (
    <div className='footer--container'>

          <div className="footer--copy">
            <p>&copy; Copyright <span className='footer-name'>2025</span>  </p> <span className='footerline'>|</span>
            <p>All rights reserved</p>
        </div>

        <div className="footer--allicons">
            <p>privacy</p>
            
            <p>Terms</p>
            
            <p>Contact</p>
        </div>
      
    </div>
  )
}

export default Footer